import { useEffect, type MouseEvent, type ReactNode } from "react";
import { createPortal } from "react-dom";

let openModalCount = 0;

export function ModalPortal({ children, onClose }: { children: ReactNode; onClose: () => void }) {
  useEffect(() => {
    openModalCount += 1;
    document.documentElement.classList.add("has-open-modal");

    return () => {
      openModalCount = Math.max(0, openModalCount - 1);
      if (openModalCount === 0) document.documentElement.classList.remove("has-open-modal");
    };
  }, []);

  const closeFromBackdrop = (event: MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) onClose();
  };

  return createPortal(
    <div className="modal-backdrop" onMouseDown={closeFromBackdrop}>
      {children}
    </div>,
    document.body,
  );
}
